import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "exam-details",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "examdetails" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
